import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Typography,
  IconButton,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const GuestListDialogs = ({ open, onClose, guests }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle fontWeight={"bold"}>
        Guest List ({guests?.length})
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {guests?.length > 0 ? (
          guests?.map((guest, index) => (
            <Chip
              key={index}
              label={guest
                ?.split(" ")
                ?.map(
                  (word) =>
                    word?.charAt(0)?.toUpperCase() +
                    word?.slice(1)?.toLowerCase()
                )
                .join(" ")}
              style={{ margin: "5px", fontWeight: "bold" }}
              size="large"
              avatar={
                <Avatar
                  sx={{
                    fontWeight: "bold !important",
                    // bgcolor: "primary.main",
                    color: "#004D72 !important",
                  }}
                  //   color="primary.main"
                >
                  {guest?.charAt(0).toUpperCase()}
                </Avatar>
              }
            />
          ))
        ) : (
          <Typography>No guests available</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default GuestListDialogs;
